export const handlelSpeak = (text) => {
  let utter = new SpeechSynthesisUtterance(text);
  // utter.lang = 'mr-IN';
  speechSynthesis.speak(utter);
};
export const handleStop = () => {
  speechSynthesis.cancel();
};
